<div class="row m-0">

  <!-- Filters Panel -->
  <div class="col-sm-6 p-2">
    <div class="card h-100">
      <div class="card-header card-header-rose-6 d-flex align-items-center justify-content-between">
        <h5 class="mb-0">Filter Items</h5>
        <button mat-raised-button color="primary" (click)="emitItems()">
          <mat-icon>check</mat-icon> Select Items
        </button>
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Brand</mat-label>
              <mat-select [formControl]="brand" (selectionChange)="search()" multiple>
                <mat-option *ngFor="let k of brands" [value]="k.manufacturer_id">{{ k.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Category</mat-label>
              <mat-select [formControl]="category" multiple="true" (selectionChange)="search()">
                <mat-option *ngFor="let c of categories" [value]="c.categoryid">{{ c.categorydescription }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Product Line</mat-label>
              <mat-select [formControl]="productLine" multiple="true" (selectionChange)="search()">
                <mat-option *ngFor="let p of productlines" [value]="p.line_field">{{ p.line_description }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Range Start</mat-label>
              <input autocomplete="off" matInput [formControl]="rangestart" (input)="search()">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Range End</mat-label>
              <input autocomplete="off" matInput [formControl]="rangeend" (input)="search()">
            </mat-form-field>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <mat-slide-toggle [formControl]="includesales" (change)="search()">Include Sale Priced Items</mat-slide-toggle>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Keywords</mat-label>
              <mat-icon matSuffix>search</mat-icon>
              <input autocomplete="off" matInput [formControl]="keywords" (keyup.enter)="$event.preventDefault(); search()">
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="exclusions?.length > 0">
          <div class="section-label">
            <ng-container *ngIf="!selectionReverse">Exclusions</ng-container>
            <ng-container *ngIf="selectionReverse">Inclusions</ng-container>
            <span class="count-badge ml-2">{{ exclusions.length }}</span>
          </div>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>Item</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of exclusions">
                <td>
                  <div class="stockid-col">{{ p.stockid }}</div>
                  <div class="item-desc">{{ p.description }}</div>
                </td>
                <td class="action-col">
                  <button mat-icon-button color="warn" matTooltip="Remove" (click)="removeExclusion(p)">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>

      </div>
    </div>
  </div>

  <!-- Results Panel -->
  <div class="col-sm-6 p-2">
    <div class="card h-100">
      <div class="card-header card-header-info-6 d-flex align-items-center justify-content-between">
        <h5 class="mb-0">
          <ng-container *ngIf="!selectionReverse">Items Affected</ng-container>
          <ng-container *ngIf="selectionReverse">Item Results</ng-container>
          <span class="count-badge ml-2" *ngIf="results?.length > 0">{{ results.length }}</span>
        </h5>
      </div>
      <div class="card-body p-0">

        <ng-container *ngIf="results?.length > 0; else emptyState">
          <div class="results-table-wrapper">
            <table class="table table-sm table-striped table-hover mb-0">
              <thead class="sticky-header">
                <tr>
                  <th>Item</th>
                  <th>DWO</th>
                  <th>Disc.</th>
                  <th class="text-right">QOH</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of dataObs | async">
                  <td>
                    <div class="stockid-col">{{ p.stockid }}</div>
                    <div class="item-desc">{{ p.description }}</div>
                  </td>
                  <td>{{ p.dwo }}</td>
                  <td>{{ p.discontinued }}</td>
                  <td class="text-right">{{ p.locstock }}</td>
                  <td class="action-col">
                    <button mat-icon-button color="warn" (click)="exludeItem(p)"
                      [matTooltip]="selectionReverse ? 'Include' : 'Exclude'">
                      <mat-icon>{{ selectionReverse ? 'add_circle_outline' : 'remove_circle_outline' }}</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <ng-template #emptyState>
          <div class="empty-state">
            <mat-icon class="empty-icon">filter_list</mat-icon>
            <p>
              <span *ngIf="!inventorysearching">Use the filters to search for items</span>
              <svg *ngIf="inventorysearching" class="spinner" width="33px" height="33px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
              </svg>
            </p>
          </div>
        </ng-template>

        <mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"
          [ngClass]="{'d-none': !results || !results.length}"></mat-paginator>
      </div>
    </div>
  </div>

</div>
